function Pager( containerEl, prevText, nextText, ellipsisText, callback, locationHashString, ignoreHashChange )
{
    this.containerEl = containerEl;
    this.callback = callback;
    this.prevText = prevText;
    this.nextText = nextText;
    this.ellipsisText = ellipsisText;
    this.ignoreHashChange = ignoreHashChange;
    this.locationHashString = !locationHashString ? "page" : locationHashString;
    this.onHashChangeSupported = !ignoreHashChange && ( "onhashchange" in window );
    if( this.onHashChangeSupported )
    {
        var oldHandler = window.onhashchange;
        var that = this;
        window.onhashchange = function()
        {
            if( oldHandler )
                oldHandler();
            if ( that._isMyLocationHashString( window.location.hash ) )
            {
                var pageNumFromHash = that.getPageNumFromHash();
                if( !pageNumFromHash )
                    pageNumFromHash = 1;
                callback( pageNumFromHash );
            }
        }
    }
}

Pager.prototype.loadPage = function( pageNum )
{
    var newHash = this._makeHashValue(pageNum);
    if( !this.ignoreHashChange && window.location.hash != newHash )
    {
        window.location.hash = newHash;
        if( !this.onHashChangeSupported )
            this.callback( pageNum );
    }
    else
    {
        // reload current page
        this.callback( pageNum );
    }
};

Pager.prototype._isMyLocationHashString = function( locationHashString )
{
    return locationHashString.search("#"+this.locationHashString+"-[0-9]+") != -1;
};

Pager.getTotalPages = function( totalItems, itemsPerPage )
{
    if(totalItems == 0 || itemsPerPage == 0)
    {
        return 1;
    }
    return Math.max(1, Math.ceil( totalItems / itemsPerPage ) );
};

Pager.prototype.draw = function( totalItems, itemsPerPage, currentPageNum )
{
    var totalPages = Pager.getTotalPages( totalItems, itemsPerPage );
    currentPageNum = currentPageNum ? Math.min( Math.max(1, currentPageNum), totalPages ) : 1;
    this._removeAll();
    this._appendBlock( "prev", this.prevText, currentPageNum > 1 ? currentPageNum - 1 : null );
    var pageNum = 1;
    var midCount = 0;
    while( pageNum <= totalPages )
    {
        if( totalPages > 9 && pageNum > 1 )
        {
            if( pageNum == 2 && currentPageNum > 5 )
            {
                this._appendBlock( "elli", this.ellipsisText, null );
                pageNum = totalPages - Math.max(6, totalPages - (currentPageNum - 2) );
                midCount++;
            }
            else if( midCount == 6 && pageNum < totalPages - 1 )
            {
                this._appendBlock( "elli", this.ellipsisText, null );
                pageNum = totalPages;
            }
            midCount++;
        }
        this._appendBlock( "page", pageNum, currentPageNum == pageNum ? null : pageNum );
        pageNum++;
    }

    this._appendBlock( "next", this.nextText, currentPageNum < totalPages ? currentPageNum + 1 : null );
};

Pager.prototype._removeAll = function()
{
    while( this.containerEl.hasChildNodes() )
        this.containerEl.removeChild( this.containerEl.lastChild );
};

Pager.prototype._makeHashValue = function( pageNum )
{
    return "#"+this.locationHashString+"-" + pageNum;
};

Pager.prototype._appendBlock = function( styleClass, content, pageNum )
{
    var block;
    if( pageNum )
    {
        if ( !this.ignoreHashChange ) {
            block = document.createElement("a");
            block.href = this._makeHashValue(pageNum);
        } else {
            block = document.createElement("div");
            block.className = "pagerItem "
        }

        var self = this;
        block.onclick = function() { self.loadPage( pageNum ); };
    }
    else
    {
        block = document.createElement("span");
    }
    block.className = block.className + styleClass;
    block.innerHTML = content;
    this.containerEl.appendChild( block );
};

Pager.prototype.getPageNumFromHash = function()
{
    if( !window.location.hash )
        return null;
    var exp = new RegExp('#'+this.locationHashString+'\-*([0-9]+)','i');
    var result = exp.exec( window.location.hash );
    return !result || result.length < 2  ? null : result[1];
};

Pager.prototype.remove = function()
{
    this._removeAll();
};

export default Pager;


// WEBPACK FOOTER //
// ./web/js/pager/Pager.js